export default __webpack_public_path__ + "static/media/leftAo.6fc8b2b0.svg";